<template>
  <div>
    <router-view class="children" />
    <div class="home_bottom init_color">
      <router-link to="/lmjhome?l=1" tag="a" class="color_home">
        <div class="home_nav" @click="_show(1)">
          <img v-if="l != 1" src="../../images/hb3.png" alt />
          <img v-else src="../../images/home1.png" alt />
          <i v-if="l == 1" style="color: rgba(92, 186, 255, 1)">商品分类</i>
          <i v-else style="color: #6D6D6D">商品分类</i>
        </div>
      </router-link>
      <router-link to="/gwhome?l=2" tag="a" class="color_home">
        <div class="home_nav" @click="_show(2)">
          <img v-if="l != 2" src="../../images/hb4.png" alt />
          <img v-else src="../../images/gwc3.png" alt />
          <i v-if="l == 2" style="color: rgba(92, 186, 255, 1)">购物车</i>
          <i v-else style="color: #6D6D6D">购物车</i>
          <span>{{$store.getters.get_user_num}}</span>
        </div>
      </router-link>
      <router-link to="/hyhome?l=3" tag="a" class="color_home">
        <div class="home_nav" @click="_show(3)">
          <img v-if="l != 3" src="../../images/hb5.png" alt />
          <img v-else src="../../images/hb2.png" alt />
          <i v-if="l == 3" style="color: rgba(92, 186, 255, 1)">会员中心</i>
          <i v-else style="color: #6D6D6D">会员中心</i>
        </div>
      </router-link>
    </div>
  </div>
</template>
<script>
import API from "../../lmj_Api/api";

export default {
  data() {
    return {
      name: "Buttom",
      show: 1,
      l: ""
    };
  },
  mounted() {
    var that = this;
    that.to();
    console.log(localStorage.to, "上一个进入的页面homes"); // 上一页面的路由信息
  },
  watch: {},
  methods: {
    //点击切换高亮
    _show(vla) {
      var that = this;
      this.show = vla;
      setTimeout(() => {
        that.l = this.$route.query.l;
      });
    },
    //跳转进来的正常高亮
    to() {
      if (this.$route.query.l) {
        this.l = this.$route.query.l;
      } else {
        this.l = 3;
        this.show = 3;
      }
    }
  }
};
</script>
<style lang="less" scoped>
//底部条
.home_bottom {
  font-size: 0.22rem;
  width: 100%;
  height: 1.2rem;
  position: fixed;
  z-index: 999;
  bottom: 0rem;
  display: flex;
  justify-content: space-around;
  align-items: center;
  text-align: center;
  background: white;
  border-top: 0.01rem solid #eee;
  .color_home {
    width: 33.33%;
    position: relative;
    font-family: PingFangSC-Medium, PingFang SC;
    font-weight: 500;
    img {
      height: 0.46rem;
      display: block;
      margin: 0.1rem auto;
    }
    span {
      background: red;
      padding: 0rem 0.1rem;
      display: inline-block;
      height: 0.34rem;
      line-height: 0.34rem;
      text-align: center;
      border-radius: 0.17rem;
      color: white;
      position: absolute;
      top: 0;
      left: 1.33rem;
      font-size: 0.24rem;
    }
    i {
      font-style: initial;
      font-size: 0.24rem;
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/pubilc/bottom.vue